import React from 'react';
import { useParams } from 'react-router-dom';

import ClientsForm from '../components/Clients/ClientsForm';

function ClientsFormPage() {
  const {
    id
  } = useParams();

  return (
    <ClientsForm id={id} />
  );
}

export default ClientsFormPage;
